import React, { useState, useRef } from 'react';

interface Props {
  text: string;
}

export default function Tooltip({ text }: Props) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  return (
    <span className="relative inline-flex items-center ml-1" ref={ref}>
      <button
        type="button"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700 text-xs font-bold leading-none focus:outline-none focus:ring-1 focus:ring-primary-400 transition-colors"
        tabIndex={-1}
        aria-label="Hilfe"
      >
        ?
      </button>
      {visible && (
        <span className="absolute z-50 left-6 top-1/2 -translate-y-1/2 w-56 bg-gray-800 text-white text-xs rounded-lg px-3 py-2 shadow-lg pointer-events-none">
          {text}
          <span className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-800" />
        </span>
      )}
    </span>
  );
}
